import { Stack, IconButton, Text } from '@fluentui/react';
import React, { useContext, useState } from 'react';
import { Capability } from '../../Common/components/Capabilities/capability';
import { ThemeContext } from '../../HubLayout/models/ThemeContext';
import { getThemeFromString } from '../../Common/util/localStorageUtils';
import { CapabilityContext } from '../../Common/components/Capabilities/CapabilityContext';
import { useIsMobile } from '../../Common/hooks/useIsMobile';

interface IAdminComponent {
    title: string;
    component: JSX.Element;
    defaultExpanded?: boolean;
}

export const AdminComponent: React.FC<IAdminComponent> = (
    props: IAdminComponent
) => {
    const themeContext = useContext(ThemeContext);
    const theme = getThemeFromString(themeContext.themeName);
    const isMobile = useIsMobile();

    const capabilities = useContext(CapabilityContext);

    const [isExpanded, setIsExpanded] = useState<boolean>(
        props.defaultExpanded ?? false
    );

    const expandSection = () => {
        setIsExpanded(!isExpanded);
    };

    // If user doesn't have admin role, don't render anything
    if (!capabilities.check(Capability.srmAdminRole)) {
        return null;
    }

    return (
        <div
            className="AdminComponent-root"
            style={{
                backgroundColor: theme.palette.white,
                borderRadius: '4px',
                boxShadow:
                    '0 3.2px 7.2px 0 rgba(0, 0, 0, .132), 0 .6px 1.8px 0 rgba(0, 0, 0, .108)',
                overflow: 'hidden',
            }}
        >
            {/* Header */}
            <div
                style={{
                    padding: isMobile ? '16px' : '16px 20px',
                    backgroundColor: theme.palette.neutralQuaternary,
                    borderBottom: `2px solid ${theme.palette.themeDark}`,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: '16px',
                    cursor: 'pointer',
                    userSelect: 'none',
                }}
                onClick={expandSection}
            >
                <Text
                    variant="xLarge"
                    styles={{
                        root: { fontWeight: 700, color: theme.palette.black },
                    }}
                >
                    {props.title}
                </Text>
                <IconButton
                    iconProps={{
                        iconName: isExpanded ? 'ChevronUp' : 'ChevronDown',
                    }}
                    title={isExpanded ? 'Collapse' : 'Expand'}
                    ariaLabel={`${isExpanded ? 'Collapse' : 'Expand'} ${
                        props.title
                    }`}
                    aria-expanded={isExpanded}
                    styles={{ root: { height: '32px' } }}
                />
            </div>

            {/* Content */}
            {isExpanded && (
                <div style={{ padding: isMobile ? '16px' : '20px' }}>
                    <Stack tokens={{ childrenGap: 16 }}>
                        {props.component}
                    </Stack>
                </div>
            )}
        </div>
    );
};
